import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TourInfoComponent } from './tour-info.component';
import { MotePipesModule } from '../../pipes/mote-pipes.module';
import { SvgIconModule } from '../../components/svg-icon';
import { LightImageModule } from '../../components/light-image/light-image.module';
import { MotesMediaModule } from '../../components/motes-media/motes-media.module';
import { PageSectionModule } from '../../components/page-section/page-section.module';
import { MiniVoucherModule } from '../../components/mini-voucher/mini-voucher.module';
import { QrDropDownModule } from '../../components/qr-drop-down/qr-drop-down.module';
import { PageSectionElementModule } from '../../components/page-section-element/page-section-element.module';
import { PreviewBannerModule } from '../../components/preview-banner/preview-banner.module';
import { TourSummaryModule } from '../../components/tour-summary/tour-summary.module';
import { StartTourButtonModule } from '../../components/start-tour-button/start-tour-button.module';

@NgModule({
    declarations: [TourInfoComponent],
    imports: [
        CommonModule,
        SvgIconModule,
        LightImageModule,
        MotePipesModule,
        MotesMediaModule,
        PageSectionModule,
        MiniVoucherModule,
        QrDropDownModule,
        PageSectionElementModule,
        PreviewBannerModule,
        TourSummaryModule,
        StartTourButtonModule
    ],
    exports: [TourInfoComponent]
})
export class TourInfoModule { }
